export const customSelectStyles = {
  control: (base, state) => ({
    ...base,
    backgroundColor: "white",
    borderColor: state.isFocused ? "#3B82F6" : "#D1D5DB", // blue-500 or gray-300
    borderWidth: "1px",
    borderRadius: "0.5rem", // rounded-lg
    padding: "2px 4px",
    boxShadow: state.isFocused ? "0 0 0 2px rgba(59,130,246,0.3)" : "none", // focus ring
    "&:hover": {
      borderColor: "#3B82F6",
    },
  }),
  valueContainer: (base) => ({
    ...base,
    padding: "0 6px",
  }),
  input: (base) => ({
    ...base,
    margin: 0,
    padding: 0,
  }),
  singleValue: (base) => ({
    ...base,
    color: "#111827", // text-gray-900
    fontSize: "0.875rem",
  }),
  placeholder: (base) => ({
    ...base,
    color: "#9CA3AF", // text-gray-400
  }),
  menu: (base) => ({
    ...base,
    borderRadius: "0.5rem",
    marginTop: "0.25rem",
    boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
    zIndex: 50,
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected
      ? "#3B82F6"
      : state.isFocused
      ? "#EFF6FF"
      : "white",
    color: state.isSelected ? "white" : "#111827",
    cursor: "pointer",
    fontSize: "0.875rem",
  }),
};
